export default __webpack_public_path__ + "static/media/news29.5c46b954.jpg";